var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polyline, _polygon5, _polygon6, _polygon7, _polygon8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNpcVega(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9cccd3;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        opacity: .6;\n      }\n\n      .cls-3 {\n        fill: #8db1b5;\n      }\n\n      .cls-4 {\n        fill: #91bfc4;\n      }\n\n      .cls-5 {\n        fill: aqua;\n      }\n\n      .cls-6 {\n        fill: #c9ecf2;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "457.75 382.11 377.83 172.9 353.36 142.85 329.41 172.9 248.96 381.85 353.36 421.3 457.75 382.11"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "201.33 518.73 501.27 518.73 521.48 493.35 185.17 493.35 201.33 518.73"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "262.43 564.06 441.28 564.06 463.7 532.24 241.85 532.24 262.43 564.06"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "234.44 542.1 468.18 542.1 491.22 517.94 215.44 517.94 234.44 542.1"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "353.01 421.03 457.41 381.84 377.48 172.63 353.01 142.58"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "291.8 494.35 184.87 493.86 273.86 289.37 328.3 243.39 291.8 494.35"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "414.84 494.35 521.77 493.86 432.78 289.37 378.35 243.39 414.84 494.35"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "239.25 493.98 291.01 493.98 329.41 243.66 239.25 493.98"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "467.27 493.98 415.51 493.98 377.11 243.66 467.27 493.98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpcVega);
export default __webpack_public_path__ + "static/media/npc-vega.d8b3969413efd23dd166a9d28340f02a.svg";
export { ForwardRef as ReactComponent };